export function formatURL(url: string, queryParams?: any) {
  if (!queryParams) return url;
  const urlParams = new URLSearchParams(queryParams).toString();
  return `${url}?${urlParams}`;
}
